import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const specs = [
  "Legkelendőbb reformer, az egészségügyi és fitnesz szakemberek kedvence",
  "Boutique stúdiók és dedikált terek számára készült",
  "A megnövelt kocsimagasság és -szélesség jobb hozzáférhetőséget és kényelmet biztosít",
  "Minden vendégtípus számára alkalmas",
  "Sokoldalú óratervezési lehetőségeket kínál",
  "Fogadja a féltornyos Vertical Frame keretet",
];

export const Story = () => (
  <section className="relative bg-[var(--ink)] text-[#faf8f5] py-24 lg:py-32 grain overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="eyebrow text-[var(--terra)] mb-5">Miért V2 Max?</p>
          <h2 className="font-serif-d font-medium text-2xl sm:text-3xl lg:text-4xl leading-tight">
            A legnagyobb gyártó gépei,
            <span className="italic text-[var(--terra)]"> brandjegyek nélkül.</span>
          </h2>
          <p className="mt-6 text-[#b8b4ae] leading-relaxed text-base">
            A V2 Max gépek ugyanazokon a gyártósorokon, ugyanazokból az anyagokból
            készülnek, mint a világ legdrágább stúdió reformerei. Az egyetlen
            különbség? Nincs rajtuk a márkanév – így Ön nem a logóért fizet,
            hanem a gépért.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 grid grid-cols-2 gap-px bg-[var(--line-dark)] border border-[var(--line-dark)] rounded-2xl overflow-hidden">
            <div className="bg-[#1c1f23] p-6">
              <p className="eyebrow text-[#8c8882] mb-2">Márkás megfelelő</p>
              <p className="font-serif-d text-2xl line-through decoration-[var(--terra)]/70">2 100 000 Ft-tól</p>
            </div>
            <div className="bg-[#1c1f23] p-6">
              <p className="eyebrow text-[var(--terra)] mb-2">Pilates Factory</p>
              <p className="font-serif-d text-2xl text-[var(--terra)]" data-testid="story-price">
                395 000 Ft-tól
              </p>
            </div>
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-7 flex flex-col justify-center">
        <div className="space-y-0 divide-y divide-[var(--line-dark)] border-y border-[var(--line-dark)]">
          {specs.map((s, i) => (
            <Reveal key={s} delay={i * 0.08}>
              <div className="flex items-start gap-5 py-6" data-testid={`spec-row-${i}`}>
                <span className="mt-0.5 w-8 h-8 rounded-full bg-[var(--terra)]/15 flex items-center justify-center shrink-0">
                  <Check className="w-4 h-4 text-[var(--terra)]" />
                </span>
                <p className="text-base text-[#d8d4ce] leading-relaxed">{s}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
